import Flex from '@creditflowresearch/uilib/Flex';
import { TileHeader } from '@creditflowresearch/uilib/Tile';
import BondsTileTools from './BondsTileTools';
import BondTypes from '../BondTypes';
import BondTypesTabSelect from '../BondTypes/BondTypesTabSelect';
import SearchContainer from '@/creditflowresearch/ui/components/bonds/common/SearchContainer';

import tileStyles from '@creditflowresearch/uilib/Tile/tile.module.scss';
import styles from './tileHeader.module.scss';

const BondsTileHeader = () => (
  <>
    <TileHeader
      title={ <h3 data-test="bondsTileTitleDesktop">BWICS &amp; Inventory</h3> }
      noDesktopBottomBorder
      dataTest="bondsTileHeader"
    >
      <Flex
        direction={ { sm: 'column-reverse', md: 'column-reverse', xl: 'row' } }
        align={ { sm: 'stretch', md: 'stretch', xl: 'center' } }
        gap={ 10 }
      >
        <div className={ tileStyles.headerSearch }>
          <SearchContainer />
        </div>
        <div className={ styles.tabSelect }>
          <BondTypesTabSelect />
        </div>
        <BondsTileTools isVisible />
      </Flex>
    </TileHeader>
    <BondTypes />
  </>
);

export default BondsTileHeader;
